import { GradientColor, defaultGradientColor } from "@shortsworks/ui";
import {
  useGetAccountWidgetSetting,
  useGetAccountSetting,
} from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import FormContainer from "src/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { useEffect } from "react";
import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { ColorsSchema } from "@app/components/WidgetStudio/Inspector/schemas/colors";

interface ColorsSchemaProps {
  borderColor: {
    type: string;
    colorStops: object[];
    angle: number;
  };
}
export interface ColorsInspectorProps extends InspectorProps {}
export const ColorsInspector = ({
  defaultFormValues,
  onValueChange,
}: ColorsInspectorProps) => {
  // 유저의 글로벌 설정 정보 우선 가져오기 필요(전역 페이지에서 가져와야 하는지도 확인 필요)
  const { data: widgetSettingsData, isSuccess: isSuccessGetWidgetSettings } =
    useGetAccountWidgetSetting<{
      // 받아오는 데이터에 대한 타입 지정 필요
      data: {
        storyBorderColor: string
        shortsBorderColor: string
      };
    }>();

  // 비동기 데이터가 먼저 선언된 뒤 defaultFromValues 가 지정되도록 관리 필요
  const { form, schemas, zodSchema, parseForm, formValues, setFormValues } =
    useFormWithSchema<ColorsSchemaProps>({
      formSchemas: ColorsSchema(defaultFormValues.shape),
      // @ts-ignore
      defaultFormValues,
      mode: "onChange",
    });

  // default value 등록, widget id가 있다면 해당 id로 가져온 정보 이용
  useEffect(() => {
    if (!isSuccessGetWidgetSettings) {
      return;
    }

    if ( widgetSettingsData.data.storyBorderColor != "") {
      setFormValues({
        // 모양에 따라 다르게 적용 필요, widgetId에서는 모양에 따른 하나의 값만 있으므로 저장 발식도 달라지게 되며 shorts 모양에서 컬러 표시
        // @ts-ignore
        borderColor: GradientColor.fromCss(
            widgetSettingsData.data.storyBorderColor,
        ),
      });
    }
    if ( widgetSettingsData.data.shortsBorderColor != "") {
      setFormValues({
        // 모양에 따라 다르게 적용 필요, widgetId에서는 모양에 따른 하나의 값만 있으므로 저장 발식도 달라지게 되며 shorts 모양에서 컬러 표시
        // @ts-ignore
        borderColor: GradientColor.fromCss(
            widgetSettingsData.data.shortsBorderColor,
        ),
      });
    }

  }, [isSuccessGetWidgetSettings]);

  // 모양에 따라 attribute가 다르게 들어가도록
  useEffect(() => {
    const color = GradientColor.new(
      formValues.borderColor?.type,
      formValues.borderColor?.colorStops,
      formValues.borderColor?.angle,
    );
    // interface 내 schema type 들이 merge 되도록 관리
    return onValueChange({
      // 모양에 따라 값 변경됨
      storyBorderColor: color.toCss(),
      shortsBorderColor: color.toCss(),
    });
  }, [formValues]);

  if (!isSuccessGetWidgetSettings) {
    return <LoaderCircle className="w-full h-6 mr-2 animate-spin" />;
  }

  return (
    <div className="flex flex-col">
      <FormContainer schemas={schemas} form={form} />
    </div>
  );
};
